import React from 'react';
import { Card, CardContent, Typography, Grid, Divider } from '@mui/material';

function FHIRForm({ fhirData }) {

    const checkB64 = (str, properties) => {
        try {
            if ("contentType" in properties) {
                var decoded1 = Buffer.from(str, 'base64')
                var encoded2 = decoded1.toString('base64')
                return str === encoded2;
            } else {
                return false
            }
        } catch (err) {
            return false
        }
    }
    const downloadPDFFile = (item, index) => {
        var blob = b64toBlob(item.data, item.contentType);
        const url = window.URL.createObjectURL(blob, { type: item.contentType });
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `item_${index}.pdf`);
        document.body.appendChild(link);
        link.click();
    }
    var b64toBlob = function (b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    const renderProperties = (properties) => {
        return Object.entries(properties).map(([key, value]) => (
            <Grid container key={key} spacing={2} sx={{ margin: '0.5rem 0' }}>
                <Grid item xs={4} sm={3} md={2} sx={{ fontWeight: 'bold' }}>
                    {key}
                </Grid>
                <Grid item xs={8} sm={9} md={10}>
                    {value !== undefined && value !== null && typeof value === 'object' ? (
                        renderProperties(value)
                    ) :
                        (checkB64(value, properties) ?
                            <Typography onClick={() => downloadPDFFile(properties, key)}
                                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue', maxWidth: '135px' }}>
                                Click to Download
                            </Typography>
                            :
                            <Typography>{value == null ? "NULL" : value}</Typography>
                        )
                    }
                </Grid>
            </Grid>
        ));
    };

    const renderResource = (resource, index) => {
        return (
            <Card key={index} variant="outlined" sx={{ marginBottom: '1rem' }}>
                <CardContent>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        {resource.resourceType}
                    </Typography>
                    <Divider sx={{ margin: '1rem 0' }} />
                    {renderProperties(resource)}
                </CardContent>
            </Card>
        );
    };

    return (
        <div>
            {
                fhirData.entry.map((entry, index) =>
                    renderResource(entry.resource, index)
                )
            }
        </div>
    );
}

export default FHIRForm;
